import { ChartOptionsProvider, CHART_FLEXED_COLOUR, CHART_FLEXED_MARKER } from './chart-options';
import { Injectable } from '@angular/core';

@Injectable()
export class EbitMarginChartOptionsProvider extends ChartOptionsProvider {

  public getOptions(company, flexedExpectation, flexedData = {}) {
    let chartOptions;
    const ebitMarginHistoric = company.platformData.ebitMarginImported.slice(-13),
      forecasts = company.platformData.ebitMarginForecasts,
      ebitCap = company.platformData.ebitMarginCap,
      flexedEbits = (flexedData['valueDrivers'] && flexedData['valueDrivers']['ebitMargin']) 
      ? flexedData['valueDrivers']['ebitMargin'].filter(item => item.value !== company.platformData.valueDrivers.ebitMargin.find(e => e.year === item.year).value)
      : [];

    //Labels for footer
    const ebitMarginExpectation = (company.platformData.ebitMarginExpectation*100).toFixed(1);
    const trailingEbit = (ebitMarginHistoric[ebitMarginHistoric.length - 1].value*100).toFixed(1);

    chartOptions = {
      title: 'EBIT Margin consistent with share price (%)',
      legend: this.defaultChartOptions.legend,
      type: 'column',
      chart: {
        spacingBottom: 80,
      },
      credits: {
        enabled: true,
        text: `Implied EBIT Margin: ${ebitMarginExpectation}%<br/>Trailing EBIT Margin: ${trailingEbit}%`,
        style: {
          color: "#333",
          cursor: "pointer",
          fontSize: "12px"
        },
        position: {
          align: 'left',
          verticalAlign: 'bottom',
          x: 10,
          y: -20
        }
      },
      xAxis: {
        minTickInterval: 1
      },
      yAxis: {
        title: {
          text: null
        }
      },
      tooltip: this.defaultChartOptions.tooltip,
      series: [
        {
          name: 'Historic',
          data: ebitMarginHistoric.map(item => [item.year, item.value * 100]),
          visible: true
        },
        {
          name: 'Forecast',
          data: forecasts.map(item => [item.year, item.value * 100]),
          type: 'line',
          visible: true
        },
        {
          name: 'CAP',
          data: ebitCap.map(item => [item.year, item.value * 100]),
          type: 'line',
          visible: true
        },
        {
          name: 'Expectation',
          type: 'line',
          data: [[ebitCap[ebitCap.length - 1].year + 1, company.platformData.ebitMarginExpectation * 100]],
          visible: true
        }]
    }

    if (flexedExpectation) {
      chartOptions.series.push({
        name: 'Flexed Expectation',
        type: 'line',
        data: [[ebitCap[ebitCap.length - 1].year + 1, flexedExpectation * 100]],
        visible: true,
        marker: {
          symbol: CHART_FLEXED_MARKER
        }
      });

      chartOptions.series.push({
        name: 'Flexed Values',
        type: 'line',
        data: flexedEbits.map(item => [item.year, item.value * 100]),
        color: CHART_FLEXED_COLOUR,
        visible: true,
        marker: {
          symbol: CHART_FLEXED_MARKER
        }
      });
      chartOptions.credits.text = `Implied EBIT Margin: ${ebitMarginExpectation}% Flexed Implied EBITM: ${(flexedExpectation * 100).toFixed(1)}%<br/>Trailing EBIT Margin: ${trailingEbit}%`;
    }
    chartOptions = this.setYMax(chartOptions);
    chartOptions = this.setYMin(chartOptions);

    return super.getOptions(company, chartOptions);
  };
}



// WEBPACK FOOTER //
// ./src/providers/chart-options/ebit-margin-options.ts